import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "updateCardSection",
    "addCardSection",
    "country",
    "vatField",
    "vatInput",
    "regionField",
    "regionInput"
  ]
  static values = {
    euCountries: Array,
    billingMethod: String
  }

  connect() {
    this.updateFieldVisibility()
    this.updateCardSectionVisibility()
  }

  countryChanged() {
    this.updateFieldVisibility()
  }

  toggleUpdateCardButton() {
    this.updateCardSectionVisibility()
  }

  updateFieldVisibility() {
    const selectedCountry = this.getSelectedCountry()
    const isSweden = this.isSweden(selectedCountry)
    const isEU = this.isEUCountry(selectedCountry)

    // VAT field: only show for EU countries except Sweden
    if (this.hasVatFieldTarget) {
      if (isEU && !isSweden) {
        this.vatFieldTarget.classList.remove('hidden')
        if (this.hasVatInputTarget) {
          this.vatInputTarget.removeAttribute('disabled')
        }
      } else {
        this.vatFieldTarget.classList.add('hidden')
        if (this.hasVatInputTarget) {
          this.vatInputTarget.setAttribute('disabled', 'disabled')
          this.vatInputTarget.value = ''
        }
      }
    }

    // Region field: hide for Sweden, show for others
    if (this.hasRegionFieldTarget) {
      if (isSweden) {
        this.regionFieldTarget.classList.add('hidden')
        if (this.hasRegionInputTarget) {
          this.regionInputTarget.setAttribute('disabled', 'disabled')
          this.regionInputTarget.value = ''
        }
      } else {
        this.regionFieldTarget.classList.remove('hidden')
        if (this.hasRegionInputTarget) {
          this.regionInputTarget.removeAttribute('disabled')
        }
      }
    }
  }

  updateCardSectionVisibility() {
    const cardRadio = this.element.querySelector('input[value="card"]')
    const invoiceRadio = this.element.querySelector('input[value="invoice"]')
    const deferredRadio = this.element.querySelector('input[value="deferred"]')

    if (!cardRadio) return

    const hasBillingMethodValue =
      this.hasBillingMethodValue && this.billingMethodValue !== undefined &&
      this.billingMethodValue !== null && this.billingMethodValue !== ''
    
    // Get the current selected billing method from the form radio buttons
    // Check which radio is actually checked, or fall back to the billingMethodValue
    let selectedBillingMethod = null
    if (cardRadio.checked) {
      selectedBillingMethod = 'card'
    } else if (invoiceRadio && invoiceRadio.checked) {
      selectedBillingMethod = 'invoice'
    } else if (deferredRadio && deferredRadio.checked) {
      selectedBillingMethod = 'deferred'
    } else if (hasBillingMethodValue) {
      selectedBillingMethod = this.billingMethodValue
    }
    
    const isCardSelected = selectedBillingMethod === 'card'
    const isDeferred = selectedBillingMethod === 'deferred'
    
    // If billing_method is 'deferred', hide all card sections
    if (isDeferred) {
      if (this.hasUpdateCardSectionTarget) {
        this.updateCardSectionTarget.classList.add('hidden')
      }
      if (this.hasAddCardSectionTarget) {
        this.addCardSectionTarget.classList.add('hidden')
      }
      return
    }

    // Show/hide update card section (when payment method exists)
    if (this.hasUpdateCardSectionTarget) {
      if (isCardSelected) {
        this.updateCardSectionTarget.classList.remove('hidden')
      } else {
        this.updateCardSectionTarget.classList.add('hidden')
      }
    }

    // Show/hide add card section (when payment method doesn't exist)
    if (this.hasAddCardSectionTarget) {
      if (isCardSelected) {
        this.addCardSectionTarget.classList.remove('hidden')
      } else {
        this.addCardSectionTarget.classList.add('hidden')
      }
    }
  }

  getSelectedCountry() {
    if (!this.hasCountryTarget) return null
    return this.countryTarget.value
  }

  isSweden(countryCode) {
    return countryCode === 'SE'
  }

  isEUCountry(countryCode) {
    if (!countryCode || !this.hasEuCountriesValue) return false
    if (!Array.isArray(this.euCountriesValue)) return false
    return this.euCountriesValue.includes(countryCode)
  }
}
